import {
  Menu as ChakraMenu,
  MenuItem as ChakraMenuItem,
  MenuItemProps,
  MenuList,
  MenuProps as ChakraMenuProps,
} from '@chakra-ui/menu';
import { ComponentWithAs } from '@chakra-ui/system';
import React from 'react';

interface MenuProps {
  triggerComponent: JSX.Element;
  menuProps?: Partial<ChakraMenuProps>;
}

export const MenuItem: ComponentWithAs<'button', MenuItemProps> = (props) => (
  <ChakraMenuItem
    fontWeight="bold"
    _focus={{ color: 'brand.500' }}
    _hover={{ color: 'brand.500' }}
    {...props}
  />
);

export const Menu: React.FC<MenuProps> = ({
  triggerComponent,
  children,
  menuProps,
}) => (
  <ChakraMenu
    placement="top-end"
    {...menuProps}
    boundary="scrollParent"
    preventOverflow={true}
  >
    {triggerComponent}
    <MenuList
      overflowY="auto"
      borderRadius="xl"
      boxShadow="xl"
      zIndex="dropdown"
    >
      {children}
    </MenuList>
  </ChakraMenu>
);
